'use client';

import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import qs from 'qs';
import { FormProvider, useForm } from 'react-hook-form';

import { SegmentPage } from '@flipster/features/src/misc/segment/segment-page';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { FormItem, SessionInput } from '@flipster/ui';
import { SessionEvent } from '@flipster/utils/segment';

import { ContinueWithApple } from '@web/app/[locale]/(web)/_auth/continue-with-apple';
import { ContinueWithGoogle } from '@web/app/[locale]/(web)/_auth/continue-with-google';
import { RegionBlocker } from '@web/hooks/useBlockedRegion';
import { SignUpSchema, signUpValidator } from '@web/utils/session-validator';

import { divider, formItem, h1, header, socialButtonGroup, wrapper } from '../_style';

const Page = () => {
  const t = useTranslations();
  const router = useRouter();

  const methods = useForm<SignUpSchema>({
    mode: 'onTouched',
    resolver: yupResolver(signUpValidator),
  });

  const {
    handleSubmit,
    formState: { isValid },
  } = methods;

  const onSubmitEmail = (data: SignUpSchema) => {
    const queryString = qs.stringify({ email: data.email });
    router.push(`/email-signup?${queryString}`);
  };

  return (
    <RegionBlocker>
      <FormProvider {...methods}>
        <SegmentPage name={SessionEvent.CreateAccountPageView} context={{ type: 'root' }} />

        <form onSubmit={handleSubmit(onSubmitEmail)}>
          <div className={wrapper}>
            <header className={header}>
              <h1 className={h1}>
                <FormattedMessage id='Autogen_common.r251126.s_Create_account' />
              </h1>
            </header>
            <FormItem name='email' label={t('Autogen_common.r251126.s_E_mail')} className={formItem}>
              <SessionInput type='email' placeholder='name@flipster.io' />
            </FormItem>
            <div className={css({ mt: 24 })}>
              <Button
                htmlType='submit'
                disabled={!isValid}
                label={t('Autogen_common.r251126.s_Continue')}
                size='large'
                css={{ w: '100%' }}
              />
            </div>
            <div className={divider}>OR</div>
            <div className={socialButtonGroup}>
              <ContinueWithGoogle label={t('Autogen_common.r251126.s_Sign_up_with_Google')} />
              <ContinueWithApple label={t('Autogen_common.r251126.s_Sign_up_with_Apple')} />
            </div>
          </div>
        </form>
      </FormProvider>
    </RegionBlocker>
  );
};

export default Page;
